import config from '../config';

export default class AppHelper {

    static getFirstTag = (list, ifEmpty) => {
        if (list && list.length) {
            return list[0];
        }
        return ifEmpty;
    }

    static getImageData = (image) => {
        if ( image != null ) {
            const extension = image.split('.').pop();
            const base = config.getMediaURL() + image.replace(/\.[^/.]+$/, "");

            return {
                imageSrc: base + '_205_205.' + extension,
                imageSrcSet: `${base}_205_205.${extension} 205w, ${base}_410_410.${extension} 410w, ${base}_660_660.${extension} 660w`
            }
        } else {
            return {
                imageSrc: '',
                imageSrcSet: ''
            }
        }
    }

    static getParameterByName = (name, url) => {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}